import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AutomapperService } from "../../../../core/automapper/automapper.service";
import { BASE_API_URL } from "../../../../core/environment.tokens";
import { SelectableInput } from "../../../../dynamic-forms/inputs/selectable-input.model";

@Injectable({
  providedIn: "root",
})
export class SingleSignInService {
  private pIsLoginRedirect = new BehaviorSubject<boolean>(false);
  isLoginRedirect = this.pIsLoginRedirect.asObservable();

  constructor(
    @Inject(BASE_API_URL)
    private readonly baseApiUrl: string,
    private http: HttpClient,
    private automapper: AutomapperService
  ) { }

  getUsersWithSameEmailAddress(loggedInUserId: number, loggedInUserEmailAddress: string, loggedInUserGroupName: string): Observable<SelectableInput[]> {
    const url = `${this.baseApiUrl}users/single/signIn?callerUserId=${loggedInUserId}&userEmailAddress=${loggedInUserEmailAddress}&groupName=${loggedInUserGroupName}`;

    return this.http.get(url).pipe(
      map(this.automapper.curryMany("UserItemModel", "SelectableInput"))
    );
  }

  setLoginRedirect(value: boolean): void {
    this.pIsLoginRedirect.next(value);
  }
}
